import { render, staticRenderFns } from "./Recs.vue?vue&type=template&id=4ef1d064&"
import script from "./Recs.vue?vue&type=script&lang=js&"
export * from "./Recs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports